// AdminPanel.jsx
import React from "react";

const AdminPanel = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-center">👑 Admin Panel</h1>
      <p className="text-center mt-4">Welcome, Admin! Here you can manage users, posts, and moderation.</p>
    </div>
  );
};

export default AdminPanel;